import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function ProductListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
